module.exports = __webpack_public_path__ + "static/media/illustration_george_app_new.f4ea4bbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration_george_app_new.svg
// module id = 338
// module chunks = 21